<div class="card mb-4" *ngIf="config">
  <div class="card-header">
    <div>
      <h4 class="mb-0">Subscription rules</h4>
      <span class="text-muted small">How subscriptions are created and renewed for this school</span>
    </div>
  </div>
  <div class="card-body">
    <div class="form-check form-switch mb-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="autoCreateStudents"
        [(ngModel)]="config.autoCreateStudentRegistration"
      />
      <label class="form-check-label" for="autoCreateStudents">
        Create a student registration automatically when a student is added
      </label>
    </div>
    <div class="form-check form-switch mb-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="autoCreateTeachers"
        [(ngModel)]="config.autoCreateTeacherRegistration"
      />
      <label class="form-check-label" for="autoCreateTeachers">
        Create a teacher registration automatically when a teacher is added
      </label>
    </div>
    <div class="form-check form-switch mb-2">
      <input
        class="form-check-input"
        type="checkbox"
        id="teacherSubscriptionEnabled"
        [(ngModel)]="config.teacherSubscriptionEnabled"
      />
      <label class="form-check-label" for="teacherSubscriptionEnabled">
        Teacher subscriptions can be created for this school
      </label>
    </div>
    <div class="form-check form-switch mb-3">
      <input
        class="form-check-input"
        type="checkbox"
        id="autoRenewEnabled"
        [(ngModel)]="config.autoRenewEnabled"
      />
      <label class="form-check-label" for="autoRenewEnabled">
        Renew subscriptions automatically every month
      </label>
    </div>

    <h6 class="mb-1">Default renewal limits</h6>
    <p class="text-muted small mb-2">
      Total paid months from activation stamped on newly created subscriptions;
      leave empty to renew until manually stopped. Changing a default never
      touches existing subscriptions.
    </p>
    <div class="row gx-3 gy-2 mb-3">
      <div class="col-12 col-sm-4 col-lg-3">
        <div class="form-floating">
          <input
            class="form-control"
            type="number"
            min="1"
            id="studentDefaultMonths"
            [(ngModel)]="config.studentRegistrationDefaultMonths"
            placeholder="No limit"
          />
          <label for="studentDefaultMonths">Student registration (months)</label>
        </div>
      </div>
      <div class="col-12 col-sm-4 col-lg-3">
        <div class="form-floating">
          <input
            class="form-control"
            type="number"
            min="1"
            id="teacherDefaultMonths"
            [(ngModel)]="config.teacherRegistrationDefaultMonths"
            placeholder="No limit"
          />
          <label for="teacherDefaultMonths">Teacher registration (months)</label>
        </div>
      </div>
      <div class="col-12 col-sm-4 col-lg-3">
        <div class="form-floating">
          <input
            class="form-control"
            type="number"
            min="1"
            id="teacherSubDefaultMonths"
            [(ngModel)]="config.teacherSubscriptionDefaultMonths"
            placeholder="No limit"
          />
          <label for="teacherSubDefaultMonths">Teacher subscription (months)</label>
        </div>
        <div class="form-text xsmall text-warning-emphasis">
          Not fully working yet: books access is not integrated with
          subscriptions — an expiry stops the billing while the teacher keeps
          the books, and only re-granting the product starts a new paid period.
        </div>
      </div>
    </div>

    <div *ngIf="configError" class="alert alert-danger py-2 small mb-3">
      {{ configError }}
    </div>
    <button
      class="btn btn-primary rounded-pill px-4 py-2"
      type="button"
      [disabled]="configSaving"
      (click)="saveConfig()"
    >
      Save rules
      <span
        *ngIf="configSaving"
        class="spinner-grow spinner-grow-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
  </div>
</div>

<app-school-subscriptions-list
  *ngIf="schoolId"
  [schoolId]="schoolId"
  [adminMode]="true"
></app-school-subscriptions-list>
